import { Container as ChakraContainer } from "@chakra-ui/react";

export const Container = ChakraContainer;
